import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { EmployeeService } from "../employee.service";
import { Employee, Supervisor} from "../employee";
import { Observable, empty } from "rxjs";
import {
  map,
  debounceTime,
  finalize,
  switchMap,
  tap,
  startWith,
  filter,
} from "rxjs/operators";
import {
  API,
  APIDefinition,
  Columns,
  Config,
  DefaultConfig,
} from "ngx-easy-table";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { Contact } from "../../contacts/contact";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { MessagerComponent } from "../../messager/messager/messager.component";
import { GlobalEmailService } from "../../utils/globalemail.service";
import { LoggingService } from "../../utils/logging.service";
import { AuthService } from "../../auth.service";
import { Region } from "src/app/location/location.component";
import { LocationService } from "src/app/location/location.service";
import { locationAdressEntity } from "src/app/location/location";
import { CityService } from "src/app/cities/cities.service";



@Component({
  selector: "app-edit-employee",
  templateUrl: "./edit-employee-dialog.html",
  styleUrls: ["./employees.component.css"],
})
export class EditEmployeeDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<EditEmployeeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Employee,
    private fb: FormBuilder,
    public service: EmployeeService,
    public cityService: CityService,
    public locationService: LocationService,
    private messager: MessagerComponent,
    public log: LoggingService,
    public ges: GlobalEmailService,
    public auth: AuthService
  ) {}
  

  canSeeRaterOfRecord : boolean = false;
  canSeeCerts : boolean = true;

  regions: Region[] = [
    {value: 'ASH', viewValue: 'ASH'},
    {value: 'ATL', viewValue: 'ATL'},
    {value: 'AUG', viewValue: 'AUG'},
    {value: 'CBS', viewValue: 'CBS'},
    {value: 'CHS', viewValue: 'CHS'},
    {value: 'CIN', viewValue: 'CIN'},
    {value: 'CLT', viewValue: 'CLT'},
    {value: 'COL', viewValue: 'COL'},
    {value: 'CSTL', viewValue: 'CSTL'},
    {value: 'GPS', viewValue: 'GPS'},
    {value: 'GRV', viewValue: 'GRV'},
    {value: 'KNX', viewValue: 'KNX'},
    {value: 'MEM', viewValue: 'MEM'},
    {value: 'MF', viewValue: 'MF'},
    {value: 'NSH', viewValue: 'NSH'},
    {value: 'Office', viewValue: 'Office'},
    {value: 'RIC', viewValue: 'RIC'},
    {value: 'RDU', viewValue: 'RDU'},
    {value: 'TRI', viewValue: 'TRI'}
  ];

  supervisors: Supervisor[] = [
    { value: 'Jacob Buckner', viewValue: 'Jacob Buckner'},
    { value: 'Ben Swiernik', viewValue: 'Ben Swiernik'},
    { value: 'Rodrigo Torres', viewValue: 'Rodrigo Torres'},
    { value: 'Jeremy Price', viewValue: 'Jeremy Price'},
    { value: 'David Bess', viewValue: 'David Bess'},
    { value: 'Matthew Forster', viewValue: 'Matthew Forster'},
    { value: 'Gregory Dejong', viewValue: 'Gregory Dejong'}
  ];

  form = new FormGroup({
    employee_id: new FormControl(this.data.employee_id || ""),
    employee_name: new FormControl(this.data.employee_name || ""),
    phone: new FormControl(this.data.phone || ""),
    initials: new FormControl(this.data.initials || ""),
    inactiveemployee: new FormControl(this.data.inactiveemployee || false),
    e_mail: new FormControl(this.data.e_mail || ""),
    start_date : new FormControl(this.data.start_date || 'null'),
    termination_date : new FormControl(this.data.termination_date || null),
    region : new FormControl(this.data.region || ""),
    employeetype : new FormControl(this.data.employeetype?.trim() || ""),
    supervisingrater : new FormControl(this.data.supervisingrater || 0),
    supervisorname: new FormControl(this.data.supervisorname || ""),
    certsobtained : this.fb.array(this.data.certsobtained || [])
  });

  @ViewChild("refname", { read: false, static: false })
  refNameInputRef: ElementRef;
  mode = this.data.mode;
  isLoading = false;
  employee$: Observable<any[]>;
  employee_name;
  supervisingratername ='';

  certifications = ['RFI', 'HvG', 'ESSF', 'ESMF', 'NGBS', 'EI', 'QAD', 'CFA', 'GV'];

  ngOnInit() {
    //pre-fill dropdowns here
      this.form.get('start_date').setValue(this.returnDate(this.data.start_date));
      this.form.get('termination_date').setValue(this.returnDate(this.data.termination_date));

      

      this.employee$ = this.form.get('supervisingrater').valueChanges.pipe(
        debounceTime(400),
        tap(() => this.isLoading = true ),
        switchMap(value =>
          value.length > 0 ? this.locationService.getEmployeesDropdown(value as string) : empty()
          .pipe(
            tap((res) => {
              this.isLoading = false;
            }),
            finalize(() => this.isLoading = false)
            )
        )
      );    
      
      if(this.data.supervisingrater && this.data.supervisingrater > 0){
        this.service.getOneEmployee(this.data.supervisingrater).subscribe((res) => {
            this.supervisingratername = res.employee_name;
        });
      }


      this.cityService.getRegions().subscribe(
        data => this.regions = data
      )

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSelectSupervisor(event){
    this.form.get('supervisingrater').setValue(event.employee_id);
    this.supervisingratername = event.employee_name;
  }

  displayFunctionEmployee(obj: any){
    if(obj) { return obj.employee_name}
  }
  
  isChecked(value: string): boolean {
    return this.form.value.certsobtained.includes(value);
  }

  onCertSelected(event, value: string){
    if(event.checked){
      this.form.value.certsobtained.push(value);
    } else {
      const index = this.form.value.certsobtained.indexOf(value);
      if (index > -1) {
        this.form.value.certsobtained.splice(index, 1);
      }
    }
  }


  returnDate(date): string {

    if (date != null) {
      let pdate = new Date(date);

      const day = pdate.getUTCDate();
      const month = pdate.getUTCMonth() + 1; // Return Value is 0 indexed
      const year = pdate.getUTCFullYear();

      return month + '/' + day + '/' + year;
    } else {
      return null;
    }
  }


  save(): void {

    this.service.saveEdit(this.data.employee_id, this.form.value).subscribe(
      (res) => {
        this.dialogRef.close();

        let changedProperties = [];
        Object.keys(this.form.controls).forEach((name) => {
          const currentControl = this.form.controls[name];

          if (currentControl.dirty) {
            changedProperties.push(
              name + ": " + this.form.controls[name].value
            );
          }
        });



        if (res.Error) {
          let errMessage = res.Message;


          this.messager.openSnackBar(
            "Error saving employee, an email with all data has been sent to support.",
            "[close]",
            "errorAlert"
          );

          this.ges
            .sendDebugEmail(
              "IMPORTANT",
              this.form.value,
              "Employee",
              errMessage
            )
            .subscribe(
              (res) => {

                if (res.Error) {
                  this.log.error(
                    "Error sending debug email for employee page: " +
                      res.Message
                  );
                } else {
                  this.log.debug(
                    "Debug email sent to support from the employee page."
                  );
                }
              },
              (err) => {
                this.log.error(
                  "Application error sending debug email: " + err.toString()
                );
              }
            );

          this.log.error(
            this.data.loggedIn +
              " encountered an error editing a contact: Submitted data: " +
              "{" +
              this.form.value +
              "} " +
              res.Message
          );
        } else {
          this.log.info(
            this.data.loggedIn +
              " saved the following edits to employee " +
              this.data.employee_name.trim() +
              " {" +
              changedProperties.toString() +
              "}"
          );
        }
      },
      (err) => {
        this.log.error(
          this.data.loggedIn +
            " encountered an error editing an employee: Submitted data: " +
            "{" +
            this.form.value.toString() +
            "} " +
            err.toString()
        );

      }
    );
  }

  add(): void {

    this.service.add(this.form.value).subscribe(
      (res) => {
        this.dialogRef.close();
        if (res.Error) {
          let errMessage = res.Message;


          this.messager.openSnackBar(
            "Error adding employee, an email with all data has been sent to support.",
            "[close]",
            "errorAlert"
          );

          this.ges
            .sendDebugEmail(
              "IMPORTANT",
              this.form.value,
              "employees",
              errMessage
            )
            .subscribe(
              (res) => {
                if (res.Error) {
                  this.log.error(
                    "Error sending debug email for employees page: " +
                      res.Message
                  );
                } else {
                  this.log.debug(
                    "Debug email sent to support from the employee page."
                  );
                }
              },
              (err) => {
                this.log.error(
                  "Application error sending debug email: " + err.toString()
                );
              }
            );

          this.log.error(
            this.data.loggedIn +
              " encountered an error adding a employee: Submitted data: " +
              "{" +
              this.form.value.toString() +
              "} " +
              res.Message
          );
        } else {
          this.log.info(
            this.data.loggedIn +
              " created " +
              this.form.value.employee_name.trim() +
              " as an employee"
          );
        }
      },
      (err) => {
        this.log.error(
          this.data.loggedIn +
            " encountered an error creating an employee: Submitted data: " +
            "{" +
            this.form.value.toString() +
            "} " +
            err.toString()
        );
      }
    );
  }
}

@Component({
  selector: "app-employees",
  templateUrl: "./employees.component.html",
  styleUrls: ["./employees.component.css"],
})
export class EmployeesComponent implements OnInit {
  public configuration: Config;
  public columns: Columns[];
  editData;

  modal = false;
  selected;

  user;
  usernamee;

  faedit = faEdit;
  fatrash = faTrashAlt;

  gridEntrie$: Observable<Employee[]>;
  displayedColumns: string[] = ["employee_name", "phone", "initials",""];
  canSeeRORIDs = [185, 3, 151, 130];
  canEditCerts = [ 185, 73, 151, 130];
  canSeeRaterOfRecord : boolean = false;
  canEditCertsEdit: boolean = false;

  constructor(
    public employeeService: EmployeeService,
    public cityService: CityService,
    public dialog: MatDialog,
    public auth: AuthService,
    public log: LoggingService
  ) {}

  ngOnInit(): void {

    this.employeeService.init();

    this.configuration = { ...DefaultConfig };
    this.configuration.tableLayout.theme = "lIGHT";
    this.configuration.tableLayout.style = "big";
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.employeeService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.employeeService.isLoading;
      })
    );

    this.auth.getUser$().subscribe((res) => {
       if( this.canEditCerts.indexOf(res['https://rhv2.com.metadata'].id) > -1){
        this.canEditCertsEdit = true;
      }
      if( this.canSeeRORIDs.indexOf(res['https://rhv2.com.metadata'].id) > -1){
        this.canSeeRaterOfRecord = true;
      }
    });

    this.columns = [
      { key: "employee_name", title: "Name", width: "30%" },
      { key: "phone", title: "Phone", width: "15%" },
      { key: "initials", title: "Initials", width: "10%" },
      { key: "e_mail", title: "Email", width: "40%" },
      { key: "", title: "", width: "5%", searchEnabled: false, orderEnabled: false },
    ];
  }



  openDialog(myData): void {

    this.employeeService
      .getOneEmployee(myData.employee_id)
      .subscribe((tdata: any) => {

        const dialogRef = this.dialog.open(EditEmployeeDialogComponent, {
          width: "400px",
          data: {
            employee_id: tdata.employee_id,
            employee_name: tdata.employee_name,
            phone: tdata.phone,
            initials: tdata.initials,
            hers_training_provider: tdata.hers_training_provider,
            employeetype: tdata.employeetype,
            hers_cert_date: tdata.hers_cert_date,
            old_rater_number: tdata.old_rater_number,
            new_rater_number: tdata.new_rater_number,
            inactiveemployee: tdata.inactiveemployee,
            e_mail: tdata.e_mail,
            e_mail_pass: tdata.e_mail_pass,
            region: tdata.region?.trim(),
            supervisingrater: tdata.supervisingrater,
            energystarqual: tdata.energystarqual,
            resnetqual: tdata.resnetqual,
            credithours: tdata.credithours,
            rateragreesigned: tdata.rateragreesigned,
            fieldtestpass: tdata.fieldtestpass,
            issupervisingrater: tdata.issupervisingrater,
            loggedIn: this.usernamee,
            start_date: tdata.start_date,
            termination_date: tdata.termination_date,
            supervisorname: tdata.supervisorname,
            canSeeRaterOfRecord: this.canSeeRaterOfRecord,
            canEditCerts: this.canEditCertsEdit,
            certsobtained: tdata.certsobtained,
            mode: 1,
          },
          panelClass: 'edit-dialog-container'
        });

        dialogRef.afterClosed().subscribe((result) => {
          this.editData = result;
        });
      });
  }

  addDialog(): void {
    const dialogRef = this.dialog.open(EditEmployeeDialogComponent, {
      width: "400px",
      data: {
        loggedIn: this.usernamee,
        canSeeRaterOfRecord: this.canSeeRaterOfRecord,
        canEditCerts : this.canEditCertsEdit,
        mode: 2,
      },
      panelClass: 'edit-dialog-container'
    });
  }

  wrongEmployeesDialog(): void {
      const dialogRef = this.dialog.open(WrongSupervisorDialogComponent, {
        width: "600px",
        data: {
          loggedIn: this.usernamee,
          mode: 3,
          items: []
        },
        panelClass: 'edit-dialog-container'
      });
  }

  toggleAccordion() {
    const content = document.getElementById('accordionContent');
    if (content) {
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    }
  }
  



}

@Component({
  selector: "app-edit-employee",
  templateUrl: "./wrongsupervisor-dialog.html",
  styleUrls: ["./employees.component.css"],
})
export class WrongSupervisorDialogComponent implements OnInit {


  isLoading = true;

  constructor(public dialogRef: MatDialogRef<WrongSupervisorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public service: EmployeeService, public cityService: CityService, public log: LoggingService, public messager: MessagerComponent
  ) {}

  ngOnInit(): void {
    this.service.getWrongSupervisors().subscribe((res) => {
      this.isLoading = false;
      const wrong = res.Wrong || [];
      const wrongID = res.WrongID || [];
      // Collapse the two parallel arrays (Wrong / WrongID) into a single list of
      // objects. Keeping them parallel and splicing by index broke when multiple
      // rows were updated: indices shifted between async callbacks and only one
      // array was spliced, so later updates read the wrong employee_id/region.
      this.data.items = wrong.map((display: string, i: number) => ({
        display,
        employee_id: wrongID[i] ? wrongID[i].employee_id : null,
        region: wrongID[i] ? wrongID[i].region : null,
        updating: false
      }));
    })
  }


  fixEmployee(item: any): void{

    if(item.updating){ return; } // guard against double-clicks while in flight
    item.updating = true;

    let manager = item.display.split('[BAMBOO]=>')[1].trim();

    let region = item.region;

    //map regions to our database aliases
    switch((region || '').toLowerCase()){
      case 'multi-family':
        region = 'MF';
        break;
      default:
        region = region;
    }

    this.service.updateSupervisor(item.employee_id, manager, region).subscribe((res) => {
      if(res.Error == false){
        // Remove this specific item by reference at resolution time, so concurrent
        // updates each remove the correct row regardless of completion order.
        const idx = this.data.items.indexOf(item);
        if(idx > -1){ this.data.items.splice(idx, 1); }
        this.messager.openSnackBar('Supervisor updated to ' + manager, 'Close', 'successAlert');
      }else{
        item.updating = false;
        this.messager.openSnackBar('Error updating supervisor: ' + res.Message, 'Close', 'errorAlert');
      }
    }, (err) => {
      item.updating = false;
      this.messager.openSnackBar('Error updating supervisor', 'Close', 'errorAlert');
    });
  }

}
